var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCollapse = function SvgCollapse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,7.15482203 L12.7440777,4.41074435 C13.0695146,4.08530744 13.5971521,4.08530744 13.922589,4.41074435 C14.2480259,4.73618126 14.2480259,5.26381874 13.922589,5.58925565 L10.5892557,8.92258898 C10.2638187,9.24802589 9.73618126,9.24802589 9.41074435,8.92258898 L6.07741102,5.58925565 C5.75197411,5.26381874 5.75197411,4.73618126 6.07741102,4.41074435 C6.40284793,4.08530744 6.93048541,4.08530744 7.25592232,4.41074435 L10,7.15482203 Z M10,12.845178 L7.25592232,15.5892557 C6.93048541,15.9146926 6.40284793,15.9146926 6.07741102,15.5892557 C5.75197411,15.2638187 5.75197411,14.7361813 6.07741102,14.4107443 L9.41074435,11.077411 C9.73618126,10.7519741 10.2638187,10.7519741 10.5892557,11.077411 L13.922589,14.4107443 C14.2480259,14.7361813 14.2480259,15.2638187 13.922589,15.5892557 C13.5971521,15.9146926 13.0695146,15.9146926 12.7440777,15.5892557 L10,12.845178 Z",
    fill: "#777776",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCollapse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/collapse.f9184c67.svg";
export { ForwardRef as ReactComponent };